import { api } from '../main-api/apiClient';

// Tenant Patient API services - for patient self-service
export const tenantPatientAPI = {
  // Profile Management
  getProfile: () => api.get('/tenant-patient/profile'),
  
  updateProfile: (profileData) => {
    const formData = new FormData();
    Object.keys(profileData).forEach(key => {
      if (profileData[key] !== null && profileData[key] !== undefined && profileData[key] !== '') {
        formData.append(key, profileData[key]);
      }
    });
    return api.put('/tenant-patient/profile', formData);
  },
  
  // Vital Signs
  getMyVitals: () => api.get('/tenant-patient/vitals'),
  
  getVitalDetail: (vitalId) => api.get(`/tenant-patient/vitals/${vitalId}`),
  
  // Recording Session Management (for when patient uses the recording link)
  getRecordingSession: (token) => api.get(`/recording/${token}`),
  
  getSessionQuestions: (token) => api.get(`/recording/${token}/questions`),
  
  uploadQuestionRecording: (token, responseId, questionId, audioFile, videoFile) => {
    const formData = new FormData();
    formData.append('response_id', responseId);
    formData.append('question_id', questionId);
    if (audioFile) formData.append('audio_file', audioFile);
    if (videoFile) formData.append('video_file', videoFile);
    
    return api.post(`/recording/${token}/upload-question`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  completeSession: (token, sessionId) => {
    const formData = new FormData();
    formData.append('session_id', sessionId);
    
    return api.post(`/recording/${token}/complete-session`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Save vitals using recording token (for patient recording sessions)
  saveVitalsFromRecording: (token, vitalsData) => {
    const formData = new FormData();
    formData.append('session_id', vitalsData.session_id);
    if (vitalsData.hr != null) formData.append('hr', String(vitalsData.hr));
    if (vitalsData.hrv != null) formData.append('hrv', String(vitalsData.hrv));
    if (vitalsData.rhythm) formData.append('rhythm', vitalsData.rhythm);
    if (vitalsData.bp_sys != null) formData.append('bp_sys', String(vitalsData.bp_sys));
    if (vitalsData.bp_dia != null) formData.append('bp_dia', String(vitalsData.bp_dia));
    if (vitalsData.quality_flag != null) formData.append('quality_flag', String(vitalsData.quality_flag));
    
    return api.post(`/recording/${token}/save-vitals`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
};

export default tenantPatientAPI;